// country
import Country from "./ProjectDetails/Country/Country";
import AddCountry from "./ProjectDetails/Country/AddCountry";
import ViewCountry from "./ProjectDetails/Country/ViewCountry";

// state
import State from "./ProjectDetails/State/State";
import AddState from "./ProjectDetails/State/AddState";
import ViewState from "./ProjectDetails/State/ViewState";

// block
import Block from "./ProjectDetails/Block/Block";
import AddBlock from "./ProjectDetails/Block/AddBlock";
import ViewBlock from "./ProjectDetails/Block/ViewBlock";

// block & Region
// import AddBlocksRegions from "./ProjectDetails/BlocksRegions/AddBlocksRegions";
// import ViewBlocksRegions from "./ProjectDetails/BlocksRegions/ViewBlocksRegions";
// import BlocksRegions from "./ProjectDetails/BlocksRegions/BlocksRegions";

// Health Safety & Environment
import Training from "./HealthSafetyEnvironment/Training/Training";
import ManageIncidents from "./HealthSafetyEnvironment/MeetingsIncidents/ManageIncidents";
import Sites from "./HealthSafetyEnvironment/Sites/Sites";
import { lazy } from "react";
import SystemNotifications from "./SystemNotifications/systemNotifications";
import Information from "./Information/Information";
import VFLExcel from "../Reports/VflReports/VFLExcel";
import AppCodes from "./AppCodes/AppCodes";
import emailTemplateManage from "../_healthSafetyEnvironment/emailTemplateManage";
import AddEditEmailTemplate from "../_healthSafetyEnvironment/emailTemplate";
import SmtpDetails from "./SmtpDetails/SmtpDetails";
import WorkflowRoleList from "./WorkflowRoleList/WorkflowRoleList";

const AddEditCapaOwner = lazy(() => import("./CapaOwner/AddEditCapaOwner"));
const BlockIp = lazy(() => import("./BlockIp/BlockIp"));
const logInHistory = lazy(() => import("./logInHistory/logInHistory"));
const systemNotifications = lazy(() =>
  import("./SystemNotifications/systemNotifications")
);
const Broadcast = lazy(() => import("./Broadcast/Broadcast"));
const changeLogs = lazy(() => import("./ChangeLogs/ChangeLogs"));
const ViewChangeLogs = lazy(() => import("./ChangeLogs/ViewChangeLogs"));
const CapaOwner = lazy(() => import("./CapaOwner/CapaOwner"));
const ViewCapaOwner = lazy(() => import("./CapaOwner/ViewCapaOwner"));
const EditCapaOwner = lazy(() => import("./CapaOwner/EditCapaOwner"));

const IncidentReports = lazy(() => import("../Reports/IncidentReports/IncidentReports"));
const VFLReports = lazy(() => import("../Reports/VflReports/VFLReports"));
const VFL = lazy(() => import("./HealthSafetyEnvironment/VFL/VFL"));
const CommonTab = lazy(() => import("./HealthSafetyEnvironment/Common/CommonTab"));

const AddHelpManual = lazy(() => import("./HelpManual/AddHelpManual"));
const ViewHelpManual = lazy(() => import("./HelpManual/ViewHelpManual"));
const EditHelpManual = lazy(() => import("./HelpManual/EditHelpManual"));
const HelpManual = lazy(() => import("./HelpManual/HelpManual"));

const GlobalSettingsRoutes = [
  /************ Material Module *************/
  /************ Country *************/
  {
    path: "/global-configuration/project-details/country/edit/:id",
    permission: ["superAdmin"],
    component: AddCountry,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/country/view/:id",
    permission: ["superAdmin"],
    component: ViewCountry,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/country/add",
    permission: ["superAdmin"],
    component: AddCountry,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/country",
    permission: ["superAdmin"],
    component: Country,
    nav: 1,
    exact: true,
  },

  /************ State *************/
  {
    path: "/global-configuration/project-details/state/edit/:id",
    permission: ["superAdmin"],
    component: AddState,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/state/view/:id",
    permission: ["superAdmin"],
    component: ViewState,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/state/add",
    permission: ["superAdmin"],
    component: AddState,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/state",
    permission: ["superAdmin"],
    component: State,
    nav: 1,
    exact: true,
  },

  /************ Block *************/
  {
    path: "/global-configuration/project-details/block/edit/:id",
    component: AddBlock,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/block/view/:id",
    component: ViewBlock,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/block/add",
    component: AddBlock,
    nav: 1,
  },
  {
    path: "/global-configuration/project-details/block",
    component: Block,
    nav: 1,
    exact: true,
  },

  // Health Safety & Environment

  {
    path: "/global-configuration/health-safety-and-environment/training",
    permission: ["superAdmin"],
    component: Training,
    exact: true,
    nav: 1,
  },
  {
    path: "/global-configuration/health-safety-and-environment/vfl",
    permission: ["superAdmin"],
    component: VFL,
    exact: true,
    nav: 1,
  },

  {
    path: "/global-configuration/health-safety-and-environment/manage-incidents",
    permission: ["superAdmin"],
    component: ManageIncidents,
    exact: true,
    nav: 3,
  },
  {
    path: "/global-configuration/health-safety-and-environment/common",
    permission: ["superAdmin"],
    component: CommonTab,
    exact: true,
    nav: 3,
  },

  {
    path: "/global-configuration/health-safety-and-environment/sites",
    permission: ["superAdmin"],
    component: Sites,
    exact: true,
    nav: 4,
  },

  /************ Block *************/
  {
    path: "/global-configuration/capa-owner/edit/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: EditCapaOwner,
    nav: 1,
  },
  {
    path: "/global-configuration/capa-owner/view/:id",
    permission: ["superAdmin", "globalAdmin"],
    component: ViewCapaOwner,
    nav: 1,
  },
  {
    path: "/global-configuration/capa-owner/add",
    permission: ["superAdmin", "globalAdmin"],
    component: AddEditCapaOwner,
    nav: 1,
  },
  {
    path: "/global-configuration/capa-owner",
    // permission: ["superAdmin", "globalAdmin", "projectAdmin"],
    permission: ["superAdmin", "globalAdmin"],
    component: CapaOwner,
    nav: 1,
  },
  {
    path: "/global-configuration/block-ip",
    permission: ["superAdmin"],
    component: BlockIp,
    nav: 1,
  },
  {
    path: "/admin-panel/log-in-history",
    permission: ["superAdmin"],
    component: logInHistory,
    nav: 1,
  },
  {
    path: "/admin-panel/system-notifications",
    permission: ["superAdmin"],
    component: systemNotifications,
    nav: 1,
  },
  {
    path: "/admin-panel/action-logs",
    permission: ["superAdmin"],
    component: changeLogs,
    nav: 1,
    exact: true,
  },
  {
    path: "/admin-panel/broadcast",
    permission: ["superAdmin"],
    component: Broadcast,
    nav: 1,
  },
  {
    path: "/global-configuration/change-logs/view/:id",
    permission: ["superAdmin"],
    component: ViewChangeLogs,
    nav: 1,
    exact: true,
  },
  {
    path: "/global-configuration/help-manual/add",
    component: AddHelpManual,
    nav: 1,
  },
  {
    path: "/global-configuration/help-manual/view/:id",
    component: ViewHelpManual,
    nav: 1,
  },
  {
    path: "/global-configuration/help-manual/edit/:id",
    component: EditHelpManual,
    nav: 1,
  },
  {
    path: "/global-configuration/help-manual",
    component: HelpManual,
    nav: 1,
  },
  {
    path: "/admin-panel/information",
    permission: ["superAdmin"], //"globalAdmin", "projectAdmin"
    component: Information,
    nav: 1,
  },
  {
    path: "/admin-panel/manage-app-codes",
    permission: ["superAdmin"], //"globalAdmin", "projectAdmin"
    component: AppCodes,
    nav: 1,
  },
  {
    path: "/admin-panel/manage-email-template",
    permission: ["superAdmin"], //"globalAdmin", "projectAdmin"
    component: emailTemplateManage,
    exact: true,
    nav: 1,
  },
  {
    path: "/admin-panel/manage-email-template/update/:id",
    permission: ["superAdmin"], //"globalAdmin", "projectAdmin"
    component: AddEditEmailTemplate,
    exact: true,
    nav: 1,
  },
  {
    path: "/admin-panel/smtp-details",
    permission: ["superAdmin"], //"globalAdmin", "projectAdmin"
    component: SmtpDetails,
    nav: 1,
  },
  {
    path: "/admin-panel/workflow-roles",
    permission: ["superAdmin"], //"globalAdmin", "projectAdmin"
    component: WorkflowRoleList,
    nav: 1,
  },
  {
    path: "/reports/incident",
    component: IncidentReports,
    nav: 1,
  },
  {
    path: "/reports/vfl",
    component: VFLReports,
    nav: 1,
  },
  {
    path: "/reports/excel/vfl",
    component: VFLExcel,
    nav: 1,
  },
];

export default GlobalSettingsRoutes;
